import React, { useCallback } from 'react';
import { VectorLayer, useSearchResultFeature } from '@agissc/ktag-map';
import styleQuery from '../../assets/geostyle/search-result-style.json';
import useAppState from '../../AppStore';

const SearchResultLayer = () => {
  const featureQuery = useSearchResultFeature();
  const feature = featureQuery.data as any;
  const setIdentifyCoordinate = useAppState((state) => state.setIdentifyCoordinate);

  const onSelect = useCallback(
    (onSelectedFeatureIds: (string | number)[]) => {
      if (!onSelectedFeatureIds.length) return;
      if (!feature?.geometry || feature?.geometry?.type !== 'Point') return;
      const coordinates = feature?.geometry?.coordinates as [number, number];
      setIdentifyCoordinate(coordinates);
    },
    [feature, setIdentifyCoordinate],
  );

  if (!feature || !styleQuery) return null;

  return (
    <VectorLayer
      features={feature}
      style={styleQuery as any}
      isVisible
      opacity={1}
      zindex={10000}
      onSelectedFeatureIdsChanged={onSelect}
    />
  );
};

export default SearchResultLayer;
